export const STATUS = {
    NEW: 'New',
    REQUEST: 'Request',
    WAITING: 'Waiting',
    COMPLETED: 'Completed'
}